/* eslint-disable react/no-danger */
import React, {useMemo, useRef, useState} from "react"

import connect from "../../connect"
import createHeadingEsiTag from "../../../../utils/createHeadingEsiTag"
import createHeadingHtml from "../../../../utils/createHeadingHtml"
import {SeoHeaderWrapper} from "../.."
import {useIsOnClient} from "../../../../hooks/useIsOnClient"

const getExistingHtml = (selector: string) => {
    const element = document.getElementById(selector)
    return element ? element.innerHTML : ""
}

interface StandardSeoHeadingProps {
    siteUrl: string
    url: string
    useDevEsi: boolean
    totalResults: number
    title: string
}

export const StandardSeoHeading = ({siteUrl, url, useDevEsi, totalResults, title}: StandardSeoHeadingProps) => {
    const {isOnClient} = useIsOnClient()
    const showTotalResults = false
    const oldUrl = useRef(url)
    const [html, setUpdateHTML] = useState(false)

    useMemo(() => {
        if (oldUrl.current !== url) {
            setUpdateHTML(true)
        }
    }, [url])

    if (!isOnClient) {
        // SSR
        const esiHeadingHtml = createHeadingEsiTag(siteUrl, useDevEsi, url, totalResults, title, showTotalResults)
        return <SeoHeaderWrapper innerHtml={esiHeadingHtml} />
    }

    if (html) {
        // Client
        const headingHtml = createHeadingHtml(totalResults, title, showTotalResults)
        return <SeoHeaderWrapper innerHtml={headingHtml} />
    }
    return <SeoHeaderWrapper innerHtml={getExistingHtml("plp-seo-heading")} />
}

export default connect(StandardSeoHeading)
